import React, { Component, Fragment } from 'react';
import { createMedia } from "@artsy/fresnel";
import _ from "lodash";
import {
  Sidebar,
  Segment,
  Menu,
  Dropdown,
  Icon,
  Container,  
  Image,
  Modal,
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { userActions } from '../../actions/user.actions';
import { settingsActions } from '../../actions/settings.actions';
import { history } from '../../helpers/history';
import { darken } from '../../helpers/color';
import './styles.css';
import { userConstants } from '../../constants/user.constants';
import logo from '../../assets/imgs/logo-station.png';

const AppMedia = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  }
});
const mediaStyles = AppMedia.createMediaStyle();
const { Media, MediaContextProvider } = AppMedia;

const NavBarMobile = ({
  children,
  leftItems,
  onPusherClick,
  handleItemClick,
  onToggle,
  visible,
  activeItem,
  authAction
}) => (
    <Sidebar.Pushable>
      <Sidebar
        as={Menu}
        className="main-menu"
        animation="overlay"
        icon="labeled"
        vertical
        visible={visible}
      >
        {_.map(leftItems, item => <Menu.Item {...item} active={activeItem === item.name} onClick={handleItemClick} />)}
      </Sidebar>
      <Sidebar.Pusher
        dimmed={visible}
        onClick={onPusherClick}
        style={{ minHeight: "100vh", width: "80% !important" }}
      >
        <Menu fixed="top">
          <Menu.Item onClick={onToggle}>
            <Icon name="sidebar" style={{ color: "white" }} />
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              {authAction}
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        {children}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );

const NavBarChildren = ({ children }) => (
  <Container style={{ marginTop: "6em" }}>{children}</Container>
);

class MainLayout extends Component {
  state = {
    activeItem: 'home',
    visible: false,
    termsModalOpen: false,
    theme: {},
    menu: [
      {
        as: "a",
        name: 'requests',
        content: 'Solicitações',
        key: 'requests',
        icon: 'list',
        permission: 'request.fetch'
      },
      {
        as: "a",
        name: 'userlock/notifications',
        key: 'userlock/notifications',
        content: 'Acessos',
        icon: 'flag',
        permission: 'access.fetch'
      },
      {
        as: "a",
        name: 'delegations',
        key: 'delegations',
        content: 'Delegações',
        icon: 'calendar check',
        permission: 'delegation.fetch'
      },
      {
        as: "a",
        name: 'users',
        key: 'users',
        content: 'Usuários',
        icon: 'user',
        permission: 'user.fetch'
      },
      {
        as: "a",
        name: 'groups',
        key: 'groups',
        content: 'Grupos',
        icon: 'users',
        permission: 'group.fetch'
      },
      {
        as: "a",
        name: 'report/index',
        content: 'Relatórios',
        icon: 'file alternate',
        permission: 'report.fetch'
      },
      {
        as: "a",
        name: 'clock',
        key: 'clock',
        content: 'Eventos de Jornada',
        icon: 'clock',
        permission: 'clock.fetch'
      },
      {
        as: "a",
        name: 'ldap',
        key: 'ldap',
        content: 'Autenticação',
        icon: 'lock',
        permission: 'ldap.fetch'
      },
      {
        as: "a",
        name: 'mail',
        key: 'mail',
        content: 'E-Mail',
        icon: 'mail',
        permission: 'mail.edit'
      },
      {
        as: "a",
        name: 'notification/config',
        key: 'notificaton',
        content: 'Notificações',
        icon: 'bell',
        permission: 'mail.edit'
      },
      {
        as: "a",
        name: 'global-settings',
        key: 'global-settings',
        content: 'Configurações',
        icon: 'cog',
        permission: 'mail.edit'
      },
    ]
  };

  componentDidMount() {
    const { dispatch } = this.props;

    const theme = JSON.parse(localStorage.getItem('theme'));    
    if (theme) {
      this.setThemeColors(theme);      
    }

    dispatch(settingsActions.fetchGlobal()).then(settings => {    
      const { info } = this.props;
      var colors = {
        PrimaryColor: '#004867',
        SecondaryColor: '#ff5958',
        Logo: logo,
      }                      

      if (info?.PrimaryColor) {
        colors.PrimaryColor = info.PrimaryColor;
      }
  
      if (info?.SecondaryColor) {
        colors.SecondaryColor = info.SecondaryColor;
      }
  
      if (info?.ImageId) {
        colors.Logo = '/api/file/data/' + info.ImageId;
      }
      localStorage.setItem('theme', JSON.stringify(colors));
      this.setThemeColors(colors);
    });
  
    this.setState({
      activeItem: history.location.pathname.split('/')[1]
    });
  }

  setThemeColors(colors) {
    document.documentElement.style.setProperty('--primaryColor', colors.PrimaryColor);      
    document.documentElement.style.setProperty('--primaryColorDark', darken(colors.PrimaryColor, -50));          
    document.documentElement.style.setProperty('--secondaryColor', colors.SecondaryColor);   
    this.setState({ theme: colors });
  }

  handleItemClick = (e, { name, permission }) => {
    this.setState({ activeItem: name, visible: false })
    history.push(`/${name}`);
  };

  handlePusher = () => {
    const { visible } = this.state;

    if (visible) this.setState({ visible: false });
  };

  handleToggle = () => this.setState({ visible: !this.state.visible });

  logout = () => {
    const { dispatch } = this.props;
    dispatch(userActions.logout());
  }

  render() {
    const { children, me, company, info } = this.props;
    if (!me) {
      return <Fragment>{children}</Fragment>;
    }

    const { theme } = this.state;
    if (info && info.AllowManagerUnblockUser && me.Role == userConstants.ROLE_MANAGER) {      
      me.permissions.push('user.fetch');
      me.permissions.push('user.unlock');
    }

    if (info && info.DelegationEnabled && me.Role == userConstants.ROLE_MANAGER) {      
      me.permissions.push('delegation.fetch');      
      me.permissions.push('delegation.create');      
    }

    if (info && !info.AllowManagerAccessLogs) {
      me.permissions = me.permissions.filter(permission => permission !== 'access.fetch');
    }        

    const { visible, menu, activeItem, termsModalOpen } = this.state;
    const leftItems = _.filter(menu, (item) => (me && me.permissions.some(r => item.permission.split('|').indexOf(r) >= 0)));
    const companyData = (company) ? company : null;
    const authAction = (
      <Fragment>
        <Icon name='user' color='grey' style={{color: 'white !important'}} />
        <Dropdown className="user-menu" text={(me) ? me.Name : ''} loading={(me && me.Name) ? false : true}>
          <Dropdown.Menu>
            {info?.TermsOfUse && <Dropdown.Item icon='file text' text='Termos de Uso' onClick={() => this.setState({ termsModalOpen: true })} />}
            <Dropdown.Item icon='sign-out' text='Sair' onClick={this.logout} />
          </Dropdown.Menu>
        </Dropdown>
      </Fragment>
    );

    return (
      <div>
        <Modal
        open={termsModalOpen}        
      >
        <ModalHeader>Termos de Uso</ModalHeader>
        <ModalContent>
        <p dangerouslySetInnerHTML={{__html: info?.TermsOfUse}}></p>
        </ModalContent>
        <ModalActions>
          <Button
            content="Fechar"
            labelPosition='right'            
            onClick={() => this.setState({ termsModalOpen: false })}
          />
        </ModalActions>
      </Modal>
      <style>{mediaStyles}</style>
      <MediaContextProvider>
        <Segment as={Media} at="sm">        
          <NavBarMobile
            company={companyData}
            activeItem={activeItem}
            leftItems={leftItems}
            handleItemClick={this.handleItemClick}
            onPusherClick={this.handlePusher}
            onToggle={this.handleToggle}
            authAction={authAction}
            visible={visible}
          >
            <NavBarChildren>{children}</NavBarChildren>
          </NavBarMobile>
        </Segment>

        <Segment as={Media} greaterThanOrEqual="md">        
          <Menu fixed="left" style={{ marginTop: "4.7em" }}>
            <Sidebar.Pushable as={Segment} className="full-height">
              <div className="navslide">
                <Sidebar className="side-menu full-width" as={Menu} animation='overlay'
                  icon='labeled' vertical visible width='thin'>
                  {_.map(leftItems, item => <Menu.Item {...item} active={activeItem === item.name} onClick={this.handleItemClick} />)}                  
                </Sidebar>                
              </div>
            </Sidebar.Pushable>
          </Menu>
          <Menu fixed="top">
            <Menu.Item className="main-menu" style={{ width: '190px' }} onClick={() => history.push('/')}>
              <Image src={theme.Logo} />
            </Menu.Item>
            <Menu.Menu position="right">
              <Menu.Item>
                {authAction}
              </Menu.Item>
            </Menu.Menu>
          </Menu>
          <NavBarChildren>{children}</NavBarChildren>
          </Segment>
        </MediaContextProvider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, settings } = state;

  return {
    me: users.me || null,
    info: settings.globalSettings || null
  };
}

const connectedMenuBand = connect(mapStateToProps)(MainLayout);
export { connectedMenuBand as MainLayout };
